import React from "react";
import "./GroupCard.css";

export default function GroupCard({ image, title, desc,paragraph, icon, accentColor = "#801AF6" }) {
  return (
    <div className="group-card">
      <div className="group-card-image-wrap">
        <img src={image} alt={title} className="group-card-image" />
      </div>
      <div className="group-card-content">
      <div className="group-card-accent" style={{ background: accentColor }} />
        <div className="group-card-title-row">
          {icon && <img src={icon} alt="icon" className="group-card-icon" />}
          <span className="group-card-title">{title}</span>
        </div>
        
        <div className="group-card-desc">{desc}</div>
        <div className="group-card-desc">{paragraph}</div>
      </div>
    </div>
  );
} 